<template>
  <gc-login-layout>
    <form @submit.prevent="handleLoginSubmit" id="login-form">
      <dx-validation-group>
        <div v-bind:class="sessionTimeOut ? 'login-header-2' : 'login-header'">
          <img :src="imgUrl" style="width: 150px" />
        </div>

        <div class="session-logout" v-if="sessionTimeOut">
          <div>
            <span
              >You have been logged out due to inactivity. Please log back in to
              continue.</span
            >
          </div>
        </div>

        <div class="dx-field">
          <dx-text-box
            placeholder="Username"
            width="100%"
            :value.sync="username"
            :elementAttr="{ id: 'user-name' }"
          >
            <dx-validator>
              <dx-required-rule message="Username is required" />
            </dx-validator>
          </dx-text-box>
        </div>

        <div class="dx-field">
          <dx-text-box
            placeholder="Password"
            width="100%"
            mode="password"
            :value.sync="password"
            :elementAttr="{ id: 'user-password' }"
          >
            <dx-validator>
              <dx-required-rule message="Password is required" />
            </dx-validator>
          </dx-text-box>
        </div>

        <div class="dx-field">
          <dx-button
            type="default"
            v-show="!loggingIn"
            text="Login"
            width="100%"
            :use-submit-behavior="true"
            :elementAttr="{ id: 'user-login' }"
          />
        </div>

        <div v-show="alert.message" class="dx-field login-error">
          <div :class="`alert ${alert.type}`">{{ alert.message }}</div>
        </div>

        <div class="dx-field">
          <DxLoadIndicator
            v-show="loggingIn"
            :height="30"
            :width="30"
            class="login-load-indicator"
          />
        </div>
      </dx-validation-group>
    </form>
  </gc-login-layout>
</template>

<script>
import DxButton from "devextreme-vue/button";
import DxTextBox from "devextreme-vue/text-box";
import DxValidationGroup from "devextreme-vue/validation-group";
import DxValidator, { DxRequiredRule } from "devextreme-vue/validator";
import { DxLoadIndicator } from "devextreme-vue/load-indicator";
import GcLoginLayout from "../v1/layouts/gc-login-layout";

// import auth from "../auth";

export default {
  data() {
    return {
      title: this.$appInfo.title,
      username: "",
      password: "",
      sessionTimeOut: false,
    };
  },
  created() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const st = urlParams.get("s_out");
    if (st) this.sessionTimeOut = st;
  },
  computed: {
    loggingIn() {
      return !!this.$store.state.authentication.status.loggingIn;
    },
    alert() {
      return this.$store.state.alert;
    },
    imgUrl() {
      let baseUrl = process.env.VUE_APP_BASE_URL;
      if (baseUrl === "/") return `${baseUrl}statics/GCORP-CX.png`;
      else return `/${baseUrl}/statics/GCORP-CX.png`;
    },
  },
  methods: {
    handleLoginSubmit(e) {
      this.sessionTimeOut = false;
      const { username, password } = this;
      const { dispatch } = this.$store;
      dispatch("alert/clear");
      if (username && password) {
        dispatch("authentication/login", { username, password });
      }
      e.preventDefault();
    },
  },
  components: {
    DxButton,
    DxTextBox,
    DxValidator,
    DxRequiredRule,
    DxValidationGroup,
    DxLoadIndicator,
    GcLoginLayout,
  },
};
</script>

<style lang="scss">
.login-header {
  text-align: center;
  margin-bottom: 40px;
}
.login-header-2 {
  text-align: center;
  margin-bottom: 10px;
}

.login-header .title {
  font-weight: bold;
  font-size: 30px;
  margin: 0;
}

#login-form .dx-texteditor-input {
  color: white;
}

.login-error {
  color: #721c24;
  background-color: #f8d7da;
  border-color: #f5c6cb;
  height: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 2px;
}

.session-logout {
  // background-color: #e2e3e5;
  height: 40px;
  // border-color: #d6d8db;
  // color: #383d41;
  border-radius: 2px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #856404;
  background-color: #fff3cd;
  border-color: #ffeeba;
  margin-bottom: 15px;

  span {
    font-size: 15px;
  }
}
</style>
